<template>
    <v-content>
        <v-layout row wrap class="footer1">
            <v-flex xs12 sm2></v-flex>
            
            <!-- Privacy Policy Links -->
            <v-flex xs12 sm4>
                <v-card flat tile class="transparent text-xs-left" :style="footerStyle">
                    <v-card-text>
                    <div class="subheading white--text font-weight-bold">LEGAL </div>
                    <div class="grey--text font-weight-light">
                        <div class="link" @click="OpenWindow(doc_type.privacy)">Privacy Policy </div>
                        <div class="link" @click="OpenWindow(doc_type.terms)">Terms & Conditions</div>
                        <div class="link" @click="OpenWindow(doc_type.disclaimer)">Disclaimer</div>
                        <div class="link" @click="OpenWindow(doc_type.cookie)">Cookie Policy</div>
                        <div class="link" @click="OpenWindow(doc_type.eula)">EULA Policy</div>
                        <div class="link" @click="OpenWindow(doc_type.returnrefund)">Return & Refund Policy</div>
                    </div>
                    </v-card-text>
                </v-card>
            </v-flex>

            <!-- Contact Details -->
            <v-flex xs12 sm5>
                <v-card flat tile class="transparent text-xs-left" :style="footerStyle">
                    <v-card-text>
                        <div class="subheading white--text font-weight-bold">CONTACT DETAILS</div>
                        <div class="grey--text font-weight-light">
                            <v-layout row>
                                <v-flex xs12 sm2>
                                    Address: 
                                </v-flex>
                                <v-flex xs12 sm10>
                                    1015 Parkway Corporate Center<br> Corporate Ave cor Parkway Place, Filinvest City<br> Alabang 1781 Muntinlupa City, Philippines
                                </v-flex>
                            </v-layout>
                            <v-layout row>
                                <v-flex xs12 sm2>
                                    Support: 
                                </v-flex>
                                <v-flex xs12 sm10>
                                    <span class="link" @click="OpenEmailWindow('mailto:support@sweldonow.ph')">
                                        <v-icon v-if="!isMobile" color="grey" small dark class="contact-icon">email</v-icon>support@sweldonow.ph
                                    </span>
                                </v-flex>
                            </v-layout>
                            <v-layout row>
                                <v-flex xs12 sm2>
                                    Billing: 
                                </v-flex>
                                <v-flex xs12 sm10>
                                    <span class="link" @click="OpenEmailWindow('mailto:billing@sweldonow.ph')">
                                        <v-icon v-if="!isMobile" color="grey" small dark class="contact-icon">email</v-icon>billing@sweldonow.ph
                                    </span>
                                </v-flex>
                            </v-layout>
                            <v-layout row>
                                <v-flex xs12 sm2>
                                    Sales: 
                                </v-flex>
                                <v-flex xs12 sm10>
                                    <span class="link" @click="OpenEmailWindow('mailto:sales@sweldonow.ph')">
                                        <v-icon v-if="!isMobile" color="grey" small dark class="contact-icon">email</v-icon>sales@sweldonow.ph
                                    </span>
                                </v-flex>
                            </v-layout>
                            <v-layout row>
                                <v-flex xs12 sm2>
                                    Mobile: 
                                </v-flex>
                                <v-flex xs12 sm10>
                                    <v-icon v-if="!isMobile" color="grey" small dark class="contact-icon">smartphone</v-icon>0922-234-0858
                                </v-flex>
                            </v-layout>
                            <v-layout row>
                                <v-flex xs12 sm2>
                                    Landline: 
                                </v-flex>
                                <v-flex xs12 sm10>
                                    <v-icon v-if="!isMobile" color="grey" small dark class="contact-icon">call</v-icon>(02) 8361-1274
                                </v-flex>
                            </v-layout>
                        </div>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout> 

        <!-- Social Media Links -->
        <v-layout align-center row wrap class="footer2">
            <v-flex xs12 sm6>
                <div v-if="isMobile" class="text-xs-center" style="margin:20px 0px 0px 0px;">
                    <v-btn v-for="(item,index) in soc_med_list" :key="index" class="white--text" :title="item.title" icon @click="openSocMed(item.link)">
                        <v-icon size="20px">{{ item.icon }}</v-icon>
                    </v-btn>
                </div>
                <div v-if="!isMobile" style="margin:20px 0px 20px 20px;">
                    <v-btn v-for="(item,index) in soc_med_list" :key="index" class="white--text" :title="item.title" icon style="margin-left:-10px;" @click="openSocMed(item.link)">
                        <v-icon size="20px">{{ item.icon }}</v-icon>
                    </v-btn>
                </div>
            </v-flex>
            <v-flex xs12 sm6>
                <v-card v-if="isMobile" flat tile class="transparent white--text text-xs-center">
                    <v-card-text class="grey--text">
                        <div style="margin:0px 15px 20px 0px;">&copy; Copyright 2024 SweldoNow OPC. All Rights Reserved.</div>
                    </v-card-text>
                </v-card>
                <v-card v-if="!isMobile" flat tile class="transparent white--text text-xs-right">
                    <v-card-text class="grey--text">
                        <div style="margin:20px 15px 20px 0px;">&copy; Copyright 2024 SweldoNow OPC. All Rights Reserved.</div>                        
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>


        <v-dialog v-model="dialog" width="700">
            <legal-docs-viewer ref="refViewer" :dialog.sync="dialog"></legal-docs-viewer>
        </v-dialog>
    </v-content>
</template>
<script>
export default {
    data() {
        return {
            soc_med_list: [
                {icon: 'fab fa-linkedin', link: 'https://www.linkedin.com/company/sweldonow',  title: 'SweldoNow LinkedIn Page'},
                {icon: 'fab fa-facebook', link: 'https://www.facebook.com/sweldonow', title: 'SweldoNow Facebook Page'},
                {icon: 'fab fa-youtube', link: 'https://www.youtube.com/@SweldoNow', title: 'SweldoNow Youtube Channel'},
                // {icon: 'fab fa-twitter', link: '', title: 'SweldoNow X account'},
            ],
            doc_type: {
                privacy: 'Privacy Policy',
                terms: 'Terms & Conditions',
                disclaimer: 'Disclaimer',
                cookie: 'Cookie Policy',
                eula: 'EULA Policy',
                returnrefund: 'Return & Refund Policy'
            },
            dialog: false,
            data: [
                {
                    type: 'Privacy Policy',
                    header: 'Privacy Policy',
                    effectiveDate: 'February 1, 2024',
                    intro: `At SweldoNow, we are committed to protecting the privacy and security of our customers' personal information. This Privacy Policy outlines the types of information we collect, how we use and safeguard it, and the choices you have regarding your personal data when using our cloud payroll system.`,
                    details: [
                        {
                            title: 'Information We Collect:',
                            description: '',
                            items: [
                                {
                                    item: 'Personal Information: We collect personal information that you provide to us, including but not limited to your name, email address, contact number, employee details, salary information, and other relevant data necessary for payroll processing.'
                                },
                                {
                                    item: 'Usage Information: We automatically collect certain information, including device type, browser type, access times, and pictures used for clock-in/out attendance management and two-factor authentication. This data is collected to ensure system compatibility, analyze usage patterns, enhance security, and provide accurate attendance records.'
                                }
                            ]
                        },
                        {
                            title: 'Use of Information:',
                            description: '',
                            items: [
                                {
                                    item: 'Payroll Processing: We collect and process personal information for the purpose of payroll processing and related services, including tax calculations, deductions, and generating payslips. '
                                },
                                {
                                    item: 'Communication: We may use your contact information to communicate with you regarding your payroll, updates, service-related announcements, and customer support inquiries.'
                                },
                                {
                                    item: `System Improvement: We may analyze usage patterns and feedback to enhance our system's performance, develop new features, and improve user experience.`
                                },
                                {
                                    item: 'Legal Compliance: We may disclose personal information if required by law or in response to valid legal requests, such as subpoenas, court orders, or government regulations.'
                                }
                            ]
                        },
                        {
                            title: 'Data Security:',
                            description: '',
                            items: [
                                {
                                    item: 'Safeguards: We implement industry-standard security measures to protect your personal information from unauthorized access, disclosure, alteration, or destruction. These measures include encryption, firewalls, access controls, and regular security assessments.'
                                },
                                {
                                    item: 'Data Transfer: We ensure that personal information transferred to and stored on our servers is done in a secure manner, utilizing encryption and secure protocols.'
                                }
                            ]
                        },
                        {
                            title: 'Data Retention:',
                            description: 'We retain your personal information for as long as necessary to fulfill the purposes outlined in this Privacy Policy, unless a longer retention period is required or permitted by law. Upon termination of your account or request for deletion, we will securely dispose of your personal information in accordance with our data retention practices.',
                            items: []
                        },
                        {
                            title: 'Your Rights:',
                            description: '',
                            items: [
                                {
                                    item: 'Access and Correction: You have the right to access and correct your personal information stored in our system. You can review, update, or delete your information by contacting our support team.'
                                },
                                {
                                    item: 'Marketing Communications: You can opt-out of receiving marketing communications from us by following the unsubscribe instructions provided in the communication or by contacting us directly.'
                                }
                            ]
                        },
                        {
                            title: 'Third-Party Services:',
                            description: 'We may engage third-party service providers to perform functions on our behalf, such as payment processing or system maintenance. These providers may have access to your personal information only to the extent necessary to perform their services and are obligated to protect it in a manner consistent with this Privacy Policy.',
                            items: []
                        },
                        {
                            title: 'Updates to Privacy Policy:',
                            description: `We may update this Privacy Policy from time to time to reflect changes in our practices or legal requirements. We will notify you of any material updates by email or through our system's interface. Please review the Privacy Policy periodically to stay informed about how we collect, use, and protect your personal information.`,
                            items: []
                        },
                        {
                            title: 'Contact Us:',
                            description: 'If you have any questions, concerns, or requests regarding this Privacy Policy or the handling of your personal information, please contact us at support@sweldonow.ph',
                            items: []
                        }
                    ],
                    footer: `By using SweldoNow's cloud payroll system, you acknowledge that you have read and understood this Privacy Policy and consent to the collection, use, and disclosure of your personal information as described herein.`
                },
                {
                    type: 'Terms & Conditions',
                    header: 'Terms and Conditions',
                    effectiveDate: 'February 1, 2024',
                    intro: 'These Terms and Conditions ("Terms") govern your use of the SweldoNow cloud payroll system (referred to as "SweldoNow" or the "Service"), provided by SweldoNow OPC, a company registered in the Philippines. By using SweldoNow, you agree to comply with and be bound by these Terms. Please read them carefully.',
                    details: [
                        {
                            title: 'Acceptance of Terms',
                            description: 'By accessing or using SweldoNow, you acknowledge that you have read, understood, and agreed to these Terms. If you do not agree with any part of these Terms, you may not use SweldoNow.',
                            items: []
                        },
                        {
                            title: 'Description of Service',
                            description: 'SweldoNow is a cloud-based payroll system that enables businesses to manage their payroll processes efficiently. The Service includes features such as employee data management, payroll calculation, tax computation, leave management, and reporting. SweldoNow may add or remove features or functionalities at its discretion.',
                            items: []
                        },
                        {
                            title: 'Registration and Account Security',
                            description: 'To use SweldoNow, you must create an account and provide accurate and complete registration information. You are responsible for maintaining the confidentiality of your account credentials and are fully responsible for all activities that occur under your account. You must notify SweldoNow immediately of any unauthorized use or suspected breach of security.',
                            items: []
                        },
                        {
                            title:'Data Privacy and Security',
                            description: `SweldoNow takes data privacy and security seriously. By using the Service, you agree to comply with SweldoNow's Privacy Policy, which explains how your personal data is collected, used, and protected. SweldoNow employs industry-standard security measures to protect your data; however, no system is entirely foolproof, and SweldoNow cannot guarantee absolute security.`,
                            items: []
                        },
                        {
                            title: 'User Responsibilities',
                            description: '',
                            items: [
                                {
                                    item: 'You are responsible for ensuring the accuracy and completeness of all information you provide to SweldoNow.'
                                },
                                {
                                    item: 'You agree not to use SweldoNow for any illegal, unauthorized, or unethical purposes.'
                                },
                                {
                                    item: 'You are responsible for maintaining the confidentiality of any login credentials or other account information.'
                                },
                                {
                                    item: 'You agree not to interfere with or disrupt the operation of SweldoNow or the networks connected to it.'
                                },
                                {
                                    item: 'You will not copy, reproduce, distribute, or modify any part of the Service without prior written consent from SweldoNow.'
                                },
                                {
                                    item: `You will not attempt to gain unauthorized access to SweldoNow's systems or reverse engineer any part of the Service.`
                                },
                            ]
                        },
                        {
                            title: 'Payment and Subscription',
                            description: '',
                            items: [
                                {
                                    item: 'SweldoNow offers different subscription plans with various features and pricing options. Details of the plans and their associated costs are available on the SweldoNow website.'
                                },
                                {
                                    item: 'You agree to pay all fees associated with your chosen subscription plan as outlined during the registration process.'
                                },
                                {
                                    item: 'Payments for subscriptions are typically billed in advance and are non-refundable.'
                                },
                                {
                                    item: 'SweldoNow may modify the pricing or features of its subscription plans. Any such changes will be communicated to you in advance.'
                                },
                                {
                                    item: 'Failure to pay subscription fees may result in suspension or termination of your access to SweldoNow.'
                                }
                            ]
                        },
                        {
                            title: 'Intellectual Property Rights',
                            description: 'SweldoNow retains all rights, title, and interest in and to the Service, including all intellectual property rights. You may not use any trademarks, logos, or other proprietary information of SweldoNow without prior written consent.',
                            items: []
                        },
                        {
                            title: 'Limitation of Liability',
                            description: 'SweldoNow acknowledges its responsibility to provide the Service with reasonable care and skill. However, to the fullest extent permitted by applicable law, SweldoNow shall not be liable for any direct, indirect, incidental, consequential, or exemplary damages, including but not limited to loss of profits, data, or use, arising out of or in connection with your use of the Service.',
                            items: []
                        },
                        {
                            title: 'Termination',
                            description: '',
                            items: [
                                {
                                    item: 'You may terminate your use of SweldoNow at any time by contacting customer support or following the account closure procedure specified by SweldoNow.'
                                },
                                {
                                    item: 'SweldoNow reserves the right to terminate or suspend your access to the Service without prior notice if you violate these Terms.'
                                },
                                {
                                    item: 'Upon termination, your access to your account and data stored on SweldoNow may be disabled, and SweldoNow shall not be liable for any loss of data.'
                                }
                            ]
                        },
                        {
                            title: 'Modifications to Terms',
                            description: 'SweldoNow reserves the right to modify or update these Terms at any time. The most current version of the Terms will be available on the SweldoNow website. By continuing to use the Service, you agree to be bound by the revised Terms.',
                            items: []
                        },
                        {
                            title: 'Governing Law and Jurisdiction',
                            description: 'These Terms shall be governed by and construed in accordance with the laws of the Republic of the Philippines. Any disputes arising out of or relating to these Terms or the Service shall be subject to the exclusive jurisdiction of the courts located in the Philippines.',
                            items: []
                        }
                    ],
                    footer: 'If you have any questions or concerns about these Terms, please contact SweldoNow customer support.'
                },
                {
                    type: 'Disclaimer',
                    header: 'Disclaimer',
                    effectiveDate: 'February 1, 2024',
                    intro: `The following disclaimer outlines the limitations and disclaimers of liability for the use of SweldoNow, a cloud-based payroll system (referred to as "SweldoNow" or the "Service") provided by SweldoNow OPC, a company registered in the Philippines. By using SweldoNow, you acknowledge and agree to the following:`,
                    details: [
                        {
                            title: 'Service Provided "As Is"',
                            description: 'SweldoNow is provided on an "as is" and "as available" basis. SweldoNow OPC makes no representations or warranties of any kind, express or implied, regarding the Service, its availability, reliability, accuracy, or fitness for a particular purpose.',
                            items: []
                        },
                        {
                            title: 'Accuracy and Completeness of Information',
                            description: 'While SweldoNow strives to provide accurate and up-to-date information, it does not guarantee the accuracy, completeness, or reliability of any information or content provided through the Service. Users are responsible for verifying the accuracy and appropriateness of any information before using it for their specific purposes.',
                            items: []
                        },
                        {
                            title: 'Third-Party Integration and External Links',
                            description: 'SweldoNow may provide integrations or links to third-party websites or services. These third-party integrations and links are provided for convenience, and SweldoNow does not endorse or assume any responsibility for the content, privacy practices, or actions of these third parties. Users are encouraged to review the terms and privacy policies of any third-party websites or services they access through SweldoNow.',
                            items: []
                        },
                        {
                            title: 'Security and Data Breaches',
                            description: 'SweldoNow implements reasonable security measures to protect user data and prevent unauthorized access or data breaches. However, no system is entirely secure, and SweldoNow cannot guarantee the absolute security of user data. Users are responsible for taking appropriate measures to protect their login credentials and any sensitive information they provide through the Service.',
                            items: []
                        },
                        {
                            title: 'Limitation of Liability',
                            description: 'To the fullest extent permitted by applicable law, SweldoNow OPC shall not be liable for any direct, indirect, incidental, consequential, or exemplary damages, including but not limited to loss of profits, data, or use, arising out of or in connection with the use or performance of the Service. This limitation of liability applies regardless of the legal theory under which damages are sought, whether in contract, tort, negligence, or otherwise.',
                            items: []
                        },
                        {
                            title: 'Indemnification',
                            description: 'Users agree to indemnify and hold SweldoNow OPC, its directors, officers, employees, and affiliates harmless from any claims, damages, liabilities, losses, costs, or expenses (including reasonable attorney fees) arising out of or in connection with their use of the Service, violation of these Terms and Conditions, or infringement of any rights of a third party.',
                            items: []
                        },
                        {
                            title: 'Modification of Service',
                            description: 'SweldoNow OPC reserves the right to modify, suspend, or discontinue any aspect or feature of the Service at any time without prior notice or liability. This includes changes to the availability, functionality, or pricing of the Service.',
                            items: []
                        },
                        {
                            title: 'Governing Law and Jurisdiction',
                            description: 'These disclaimers shall be governed by and construed in accordance with the laws of the Republic of the Philippines. Any disputes arising out of or relating to these disclaimers or the use of SweldoNow shall be subject to the exclusive jurisdiction of the courts located in the Philippines.',
                            items: []
                        },
                    ],
                    footer: 'Please read these disclaimers carefully before using SweldoNow. If you do not agree with any part of these disclaimers, you should refrain from using the Service.'
                },
                {
                    type: 'Cookie Policy',
                    header: 'Cookie Policy',
                    effectiveDate: 'February 1, 2024',
                    intro: `This Cookie Policy ("Policy") explains how SweldoNow OPC ("SweldoNow," "we," "us," or "our") uses cookies and similar technologies on the SweldoNow website and cloud payroll system (referred to as "SweldoNow" or the "Service"). By using SweldoNow, you consent to the use of cookies as described in this Policy.`,
                    details: [
                        {
                            title: 'What are Cookies?',
                            description: 'Cookies are small text files that are stored on your device (computer, tablet, or mobile) when you visit a website. They enable the website to recognize your device, remember your preferences, and provide a personalized user experience.',
                            items: []
                        },
                        {
                            title: 'How We Use Cookies',
                            description: 'SweldoNow uses cookies and similar technologies for various purposes, including but not limited to:',
                            items: [
                                {
                                    item: 'Providing and improving the functionality of the Service'
                                },
                                {
                                    item: 'Analyzing usage patterns and performance of the Service'
                                },
                                {
                                    item: 'Customizing your experience and remembering your preferences'
                                },
                                {
                                    item: 'Delivering targeted advertisements and marketing communications'
                                },
                                {
                                    item: 'Preventing fraudulent activities and enhancing security'
                                }
                            ]
                        },
                        {
                            title: 'Types of Cookies We Use',
                            description: '',
                            items: [
                                {
                                    item: 'Essential Cookies: These cookies are necessary for the operation of SweldoNow and enable you to access and use the Service. They are essential for features such as user authentication, account security, and system management.'
                                },
                                {
                                    item: 'Analytics and Performance Cookies: We use these cookies to collect information about how users interact with SweldoNow, including pages visited, time spent on each page, and any errors encountered. This data helps us analyze and improve the performance and usability of the Service.'
                                },
                                {
                                    item: 'Functionality Cookies: These cookies allow us to remember your preferences and provide personalized features. For example, they may remember your language preference, region, or settings.'
                                },
                                {
                                    item: 'Advertising and Targeting Cookies: SweldoNow may work with third-party advertising partners who use cookies to deliver targeted advertisements based on your interests and online activities. These cookies may track your browsing behavior across different websites.'
                                }
                            ]
                        },
                        {
                            title: 'Third-Party Cookies',
                            description: 'SweldoNow may allow third-party service providers to set and access their cookies on your device. These providers may include analytics and advertising partners. Please note that we do not have control over these third-party cookies and their use is subject to their respective privacy policies.',
                            items: []
                        },
                        {
                            title: 'Managing Cookies',
                            description: 'Most web browsers allow you to control and manage cookies through their settings. You can typically modify your browser settings to accept or reject cookies, or to prompt you before accepting a cookie. However, please note that disabling or blocking certain cookies may affect the functionality and performance of SweldoNow.',
                            items: []
                        },
                        {
                            title: 'Updates to the Cookie Policy',
                            description: 'SweldoNow reserves the right to update or modify this Cookie Policy at any time. Any changes will be effective immediately upon posting the revised Policy on the SweldoNow website. We encourage you to review this Policy periodically for any updates.',
                            items: []
                        },
                        {
                            title: 'Contact Us',
                            description: `If you have any questions or concerns about this Cookie Policy or SweldoNow's use of cookies, please contact us at support@sweldonow.ph`,
                            items: []
                        },
                    ],
                    footer: 'By continuing to use SweldoNow, you consent to the use of cookies as described in this Cookie Policy.'
                },
                {
                    type: 'EULA Policy',
                    header: 'EULA Policy',
                    effectiveDate: 'February 1, 2024',
                    intro: `This End User License Agreement ("Agreement") is a legal agreement between you (referred to as "User" or "You") and SweldoNow ("Company" or "We") governing the use of our cloud payroll service (referred to as the "Service"). By using the Service, you agree to be bound by the terms and conditions of this Agreement. If you do not agree with these terms and conditions, you should not use the Service.`,
                    details: [
                        {
                            title: 'Grant of License',
                            description: '',
                            items: [
                                {
                                    item: 'Subject to the terms and conditions of this Agreement, the Company grants you a non-exclusive, non-transferable, revocable license to access and use the Service for your internal payroll processing and related purposes.'
                                },
                                {
                                    item: 'This license is granted solely for your use and does not extend to any third party. You may not sublicense, distribute, transfer, or assign your rights under this license without the prior written consent of the Company.'
                                }
                            ]
                        },
                        {
                            title: 'Intellectual Property Rights',
                            description: '',
                            items: [
                                {
                                    item: 'The Service, including but not limited to software, trademarks, logos, and other intellectual property, is the sole property of the Company. This Agreement does not grant you any ownership or rights to the Service, except as expressly stated herein.'
                                },
                                {
                                    item: 'You shall not modify, adapt, translate, reverse engineer, decompile, disassemble, or create derivative works based on the Service, except to the extent expressly permitted by applicable law.'
                                }
                            ]
                        },
                        {
                            title: 'User Responsibilities',
                            description: '',
                            items: [
                                {
                                    item: 'You are responsible for maintaining the confidentiality and security of your account credentials and any other login information associated with the Service. You agree to promptly notify the Company of any unauthorized access or use of your account.'
                                },
                                {
                                    item: 'You shall use the Service in compliance with all applicable laws and regulations, including but not limited to data protection, privacy, and labor laws in the Philippines.'
                                },
                                {
                                    item: 'You are responsible for the accuracy and legality of the data entered into the Service and for complying with any legal obligations regarding the processing and protection of personal data.'
                                }
                            ]
                        },
                        {
                            title: 'Data Privacy and Security',
                            description: '',
                            items: [
                                {
                                    item: 'The Company takes data privacy and security seriously. We implement reasonable measures to protect your data from unauthorized access or disclosure. However, you understand and acknowledge that no system can guarantee absolute security.'
                                },
                                {
                                    item: `By using the Service, you consent to the collection, processing, and storage of your data in accordance with the Company's Privacy Policy.`
                                }
                            ]
                        },
                        {
                            title: 'Limitation of Liability',
                            description: '',
                            items: [
                                {
                                    item: 'To the maximum extent permitted by law, the Company shall not be liable for any direct, indirect, incidental, consequential, or special damages arising out of or in connection with the use or inability to use the Service, including but not limited to loss of profits, data, or business opportunities.'
                                }
                            ]
                        },
                        {
                            title: 'Termination',
                            description: '',
                            items: [
                                {
                                    item: 'The Company reserves the right to suspend, terminate, or restrict your access to the Service at any time, with or without cause and without prior notice.'
                                },
                                {
                                    item: 'Upon termination, you must cease all use of the Service and destroy any copies of software or documentation provided by the Company.'
                                }
                            ]
                        },
                        {
                            title: 'Governing Law and Jurisdiction',
                            description: '',
                            items: [
                                {
                                    item: 'This Agreement shall be governed by and construed in accordance with the laws of the Republic of the Philippines. Any dispute arising out of or in connection with this Agreement shall be subject to the exclusive jurisdiction of the courts of the Philippines.'
                                }
                            ]
                        },
                        {
                            title: 'Entire Agreement',
                            description: '',
                            items: [
                                {
                                    item: 'This Agreement constitutes the entire agreement between you and the Company regarding the use of the Service and supersedes any prior or contemporaneous agreements, understandings, or representations, whether oral or written.'
                                }
                            ]
                        },
                    ],
                    footer: '<br>By using the Service, you acknowledge that you have read, understood, and agree to be bound by the terms and conditions of this Agreement.<br><br>If you have any questions or concerns regarding this Agreement, please contact us at support@sweldonow.ph.'
                },
                {
                    type: 'Return & Refund Policy',
                    header: 'Return & Refund Policy',
                    effectiveDate: 'February 1, 2024',
                    intro: `Thank you for choosing SweldoNow.ph, our Cloud Payroll system. We strive to provide you with a reliable and efficient service. This Return and Refund Policy explains the terms and conditions regarding cancellations and refunds for our Cloud Payroll system in the Philippines.`,
                    details: [
                        {
                            title: 'No Refund Policy',
                            description: 'All purchases and payments made for our Cloud Payroll system are non-refundable. We do not offer refunds for any reason, including but not limited to:',
                            items: [
                                {
                                    item: 'Subscription fees'
                                },
                                {
                                    item: 'Customization fees'
                                },
                                {
                                    item: 'Fees for additional services or modules'
                                },
                                {
                                    item: 'Any other fees associated with our Cloud Payroll system'
                                }
                            ]
                        },
                        {
                            title: 'Cancellation',
                            description: '',
                            items: [
                                {
                                    item: 'Customers have the right to cancel their subscription at any time. However, please note that the cancellation will not entitle the customer to a refund or partial refund of any kind.'
                                },
                                {
                                    item: 'To cancel your subscription, please follow the instructions provided in our platform or contact our customer support team at support@sweldonow.ph.'
                                }
                            ]
                        },
                        {
                            title: 'Exceptions',
                            description: 'There are no exceptions to our "No Refund" policy. Regardless of the circumstances, including but not limited to service utilization, service performance, or changes in business requirements, no refunds will be granted.',
                            items: []
                        },
                        {
                            title: 'Contact Information',
                            description: 'If you have any questions or concerns regarding our Return and Refund Policy, please contact our customer support team at support@sweldonow.ph.',
                            items: []
                        },
                    ],
                    footer: 'Please note that this Return and Refund Policy is subject to change without prior notice. We recommend reviewing this policy periodically for any updates.'
                }
            ]
        }
    },
    components: {
        'legal-docs-viewer': () => import("@/components/LegalDocsViewer"),
    },
    methods: {    
        openSocMed(url) {
            if (url)  window.open(url, '_blank')
        },
        OpenEmailWindow(url) {
            window.open(url, '_blank')
        },
        OpenWindow(type) {
            const selectedData = this.data.filter(x=> x.type == type)[0]
            this.$refs.refViewer.setData(selectedData)
            this.dialog = true
        }    
    },
    computed: {
        footerStyle() {
            return this.isMobile ? "margin:5px 0px 0px 0px;" : "margin:30px;"
        }
    },
    created() {
    }
}
</script>
<style scoped>
.footer1 {
    background-color:#212121;
    height:auto;
}
.footer2 {
    background-color:#000000;
    height:auto;
}
.link:hover {
    text-decoration: underline;
    color:#1976D2;
    cursor:pointer;
}
.contact-icon {
    margin-right:5px;
}
</style>